module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-ties.a0207794.png";